import { BorrowUsdcViaUsdsBanner } from '../../components/borrow-usdc-via-usds-banner/BorrowUsdcViaUsdsBanner'
import { InterestRateModelPanel } from '../../components/interest-rate-model-panel/InterestRateModelPanel'
import { MarketOverview as MarketOverviewPanel } from '../../components/market-overview/MarketOverview'
import { MyWalletPanel } from '../../components/my-wallet/MyWalletPanel'
import { OraclePanel } from '../../components/oracle-panel/OraclePanel'
import { BorrowStatusPanel } from '../../components/status-panel/BorrowStatusPanel'
import { CollateralStatusPanel } from '../../components/status-panel/CollateralStatusPanel'
import { EModeStatusPanel } from '../../components/status-panel/EModeStatusPanel'
import { SupplyStatusPanel } from '../../components/status-panel/SupplyStatusPanel'
import { MarketDetailsViewProps } from '../types'
import { BackNav } from './BackNav'
import { Header } from './Header'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/ui/atoms/tabs/Tabs'
import { PageLayout } from '@/ui/layouts/PageLayout'
import { cn } from '@/ui/utils/style'

export function CompactView({
  token,
  aToken,
  variableDebtTokenAddress,
  chainName,
  chainId,
  chainMismatch,
  marketOverview,
  walletOverview,
  openConnectModal,
  openSandboxModal,
  oracleInfo,
  interestRateModel,
  sllManaged,
  swapAvailable,
  usdcViaUsdsProxyMarket,
  className,
}: MarketDetailsViewProps) {
  return (
    <PageLayout className={cn('gap-0', className)}>
      <BackNav chainId={chainId} />
      <Header
        token={token}
        aToken={aToken}
        variableDebtTokenAddress={variableDebtTokenAddress}
        chainName={chainName}
        chainMismatch={chainMismatch}
        chainId={chainId}
        sllManaged={sllManaged}
        swapAvailable={swapAvailable}
        isUsdcViaUsdsProxyMarket={usdcViaUsdsProxyMarket?.selected ?? false}
      />
      <Tabs defaultValue="overview">
        <TabsList className="bg-body pt-2">
          <TabsTrigger value="overview">Overview</TabsTrigger>
          <TabsTrigger value="actions">Actions</TabsTrigger>
        </TabsList>
        <TabsContent value="overview" className="flex flex-col gap-4">
          {usdcViaUsdsProxyMarket?.showBorrowFromProxyMarketBanner && (
            <BorrowUsdcViaUsdsBanner link={usdcViaUsdsProxyMarket.link} />
          )}
          {(marketOverview.borrow.status === 'no' ? !marketOverview.summary.borrowed.isZero() : true) && (
            <MarketOverviewPanel token={token} {...marketOverview.summary} />
          )}
          {marketOverview.supply && <SupplyStatusPanel token={token} {...marketOverview.supply} />}
          <CollateralStatusPanel {...marketOverview.collateral} />
          {marketOverview.eMode && <EModeStatusPanel {...marketOverview.eMode} />}
          <BorrowStatusPanel token={token} {...marketOverview.borrow} />
          {interestRateModel && <InterestRateModelPanel {...interestRateModel} />}
          <OraclePanel {...oracleInfo} />
        </TabsContent>
        <TabsContent value="actions" className="px-3">
          <MyWalletPanel
            openSandboxModal={openSandboxModal}
            walletOverview={walletOverview}
            openConnectModal={openConnectModal}
            chainMismatch={chainMismatch}
          />
        </TabsContent>
      </Tabs>
    </PageLayout>
  )
}
